import React from "react";
import PropTypes from "prop-types";

const HistoryCard = ({
	imgSrc,
	title,
	excerpt,
	altText,
	year,
	itemId,
	setWindowLocationHash,
}) => {

	const placeholderImgSrc = `${mainScript.assetPath}images/png/placeholder/bmo-placeholder@2x.png`;

	const values = {
		image: imgSrc ? imgSrc : placeholderImgSrc,
		title: title ? title : "Untitled",
		excerpt: excerpt ? excerpt : "",
		altText: altText ? altText : "",
		year: year ? year : "",
	};

	return (
		<li
			className="history-page-card"
			data-aos="fade-up"
			onClick={() => setWindowLocationHash(itemId)}
		>
			<div className="aspect-ratio-box">
				<img
					className="history-page-card__img"
					src={values.image}
					alt={values.altText}
				/>
			</div>
			<p className="history-page-card__year">{values.year}</p>
			<h2
				className="history-page-card__title"
				dangerouslySetInnerHTML={{ __html: values.title }}
			></h2>
			<p
				className="history-page-card__excerpt"
				dangerouslySetInnerHTML={{ __html: values.excerpt }}
			></p>
			<button
				className="history-page-card__psuedo-button"
				aria-controls={`modal-${itemId}`}
				aria-label={`View details for ${values.title}`}
			></button>
		</li>
	);
};

export default HistoryCard;

HistoryCard.propTypes = {
	imgSrc: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
	title: PropTypes.string,
	excerpt: PropTypes.string,
	altText: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
	year: PropTypes.string,
	language: PropTypes.string,
	setWindowLocationHash: PropTypes.func,
	itemId: PropTypes.string,
};
